export default "/images/b8e26a588db8b543471902b05618a6de.avif";